const breadCrumb = "Rendimento - Rendimento";

const routes = [
  {
    path: "/gerar-rendimento-ensino-e-disiciplina",
    name: "gerar-rendimento-ensino-e-disiciplina",
    meta: {
      requireAuth: false,
      // allowedPermissions: ["fechamento_carga_list"],
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/GerarRendimentoPorEnsinoEDisciplina/GerarRendimentoPorEnsinoEDisciplina.vue"
      ),
  },
];

export default routes;
